import type { NpcDef } from '../../npcs/npcs';
import type { ProceduralRoomContent } from './types';

export function treasureRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: 'Phòng Báu Vật',
    description: 'Rương cũ kỹ lấp lánh.',
    safetyTag: 'Báu vật',
    bgImageKey: 'bg_treasure_room',
    isCleared: false,
    isRequiredInteraction: true,
    options: [
      {
        id: `chest_${floor}`,
        action: 'OPEN_CHEST',
        actionText: '📦 Mở rương (+vàng & vật phẩm)',
        consequence: {
          gainGold: 80 + floor * 20,
          grantItemId: 'ember_oil',
          grantItemQty: 1,
          setCleared: true,
          message: '📦 Bạn mở rương — vàng và Dầu Tro Nóng.',
        },
      },
    ],
  };
}

export function npcRoomContent(npc: NpcDef): ProceduralRoomContent {
  return {
    name: `${npc.name} · ${npc.title}`,
    description: npc.description,
    safetyTag: 'Gặp gỡ trong mê cung',
    bgImageKey: 'bg_npc_room',
    isCleared: true,
    isRequiredInteraction: false,
    npcId: npc.id,
    options: npc.interactions.map((option) => ({
      ...option,
      consequence: { ...option.consequence },
    })),
  };
}

export function trapRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: 'Hành Lang Bẫy',
    description: 'Một sai sót là cái chết (1 HP).',
    safetyTag: 'Bẫy',
    bgImageKey: 'bg_trap_room',
    isCleared: false,
    isRequiredInteraction: true,
    options: [
      {
        id: `trap_safe_${floor}`,
        action: 'DISARM_TRAP',
        actionText: '🔧 Gỡ bẫy (15 MP)',
        consequence: { spendMana: 15, setCleared: true, message: '🔧 Gỡ bẫy thành công.' },
      },
      {
        id: `trap_rush_${floor}`,
        action: 'RUSH_TRAP',
        actionText: '⚠️ Xông qua (chết nếu trúng)',
        consequence: { damageHp: 1, message: '⚠️ Bẫy kích hoạt — bạn gục.' },
      },
    ],
  };
}

export function secretRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: 'Mật Thất',
    description: 'Khe tường hé lộ kho ẩn.',
    safetyTag: 'Bí mật',
    bgImageKey: 'bg_secret_room',
    isCleared: false,
    isRequiredInteraction: true,
    options: [
      {
        id: `secret_${floor}`,
        action: 'OPEN_CHEST',
        actionText: '👁️ Thu thập bảo vật',
        consequence: {
          gainGold: 150,
          grantItemId: 'tome_radiant_bolt',
          grantItemQty: 1,
          setCleared: true,
          message: '👁️ Bạn tìm thấy vàng và Sách Phép Quang Tiễn.',
        },
      },
    ],
  };
}

export function emptyRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: 'Sảnh Trống',
    description: 'Yên ắng bất thường. Nghỉ ở đây rất nguy hiểm.',
    safetyTag: 'Không an toàn',
    bgImageKey: 'bg_enemy_room',
    isCleared: true,
    isRequiredInteraction: false,
    options: [
      {
        id: `unsafe_rest_${floor}`,
        action: 'REST_UNSAFE',
        actionText: '💤 Nghỉ tạm (25% MP — phục kích)',
        consequence: {
          healMpPercent: 25,
          triggerCombat: true,
          enemyId: 'ambusher',
          message: '⚡ Phục kích! Hồi 25% MP.',
        },
      },
    ],
  };
}
